<template>
    <router-link :to="getTo()">
        <slot />
    </router-link>
</template>
<script>
export default {
  props: ["to"],
  methods: {
    getTo() {
      if (typeof this.to !== "string") {
        return this.to
      }
      let locale = this.$route.params.locale
          if (!locale) {
              locale = this.$i18n.locale;
              if (typeof locale === 'undefined') { //Defaultwert setzen beim Startup der Page
                  locale = "de"; 
              }
        }
      // we strip leading and trailing slashes and prefix
      // the current locale
      return `/${locale}/${this.to.replace(/^\/|\/$/g, "")}`
    }
  }
}
</script>